export const cvsHeaderType = [
    // headersPartOne
    { key: 'betId', displayLabel: 'Bet Id' },
    { key: 'takenBy', displayLabel: 'Taken by' },
    { key: 'offeredBy', displayLabel: 'Offered by' },
    { key: 'accountId', displayLabel: 'Account ID' },
    { key: 'name', displayLabel: 'Name' },
    { key: 'placementDate', displayLabel: 'Placement Date' },
    { key: 'settledDate', displayLabel: 'Settlement Date' },
    { key: 'sf', displayLabel: 'SF' },
    { key: 'inPlay', displayLabel: 'In-play' },
    { key: 'sport', displayLabel: 'Sport' },
    { key: 'competition', displayLabel: 'Competition' },
    { key: 'event', displayLabel: 'Event' },
    { key: 'market', displayLabel: 'Market' },
    { key: 'selection', displayLabel: 'Selection' },
    { key: 'price', displayLabel: 'Price' },
    { key: 'decimalPrice', displayLabel: 'Decimal price' },
    { key: 'accumulator', displayLabel: 'Accumulator price' },
    { key: 'priceType', displayLabel: 'Price type' },

    // This header didn't contain a key in the old code.
    { key: 'startingPrice', displayLabel: 'Starting price' },

    // headersPartTwo
    { key: 'ew', displayLabel: 'EW' },
    { key: 'ewTerms', displayLabel: 'EW terms' },
    { key: 'betType', displayLabel: 'Bet type' },
    { key: 'stakePerLine', displayLabel: 'Stake per line' },
    { key: 'totalStake', displayLabel: 'Total stake' },
    { key: 'results', displayLabel: 'Results' },
    { key: 'payout', displayLabel: 'Payout' },
    { key: 'maxLineSteak', displayLabel: 'Max line stake' },
    { key: 'stakePerLineByMaxAllowedBet', displayLabel: 'Stake per line/Max allowed bet' },
    { key: 'channel', displayLabel: 'Channel' },
    { key: 'status', displayLabel: 'Status' },
    { key: 'affiliate', displayLabel: 'Affiliate' },
    { key: 'comment', displayLabel: 'Comment' },
    { key: 'ipAddress', displayLabel: 'Ip Address' },
];
